import { debug } from "../../utils";

export const ACTION_MSB_LIST_CHANGED = "ACTION_MSB_LIST_CHANGED";
export const ACTION_DEVICE_TYPES_CHANGED = "ACTION_DEVICE_TYPES_CHANGED";
export const ACTION_RULE_STANDARD_CHANGED = "ACTION_RULE_STANDARD_CHANGED";
export const ACTION_RULE_CATEGORIES_CHANGED = "ACTION_RULE_CATEGORIES_CHANGED";
export const ACTION_VALIDATION_RESULT_LIST_CHANGED = "ACTION_VALIDATION_RESULT_LIST_CHANGED";
export const ACTION_DEVICES_CHANGED = "ACTION_DEVICES_CHANGED";
export const ACTION_RULES_CHANGED = "ACTION_RULES_CHANGED";
export const ACTION_VALIDATE_TABLE_CLEARED = "ACTION_VALIDATE_TABLE_CLEARED";

const initState = {
    validationResultList: [],
    totalRecords: 0,
    metadata: { whitelisted: 0 }
}
//export function ValidatePageReducer(state = {}, action) {
export function ValidatePageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_MSB_LIST_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_MSB_LIST_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICE_TYPES_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_DEVICE_TYPES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULE_STANDARD_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_RULE_STANDARD_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULE_CATEGORIES_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_RULE_CATEGORIES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICES_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_DEVICES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULES_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_RULES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_VALIDATION_RESULT_LIST_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_VALIDATION_RESULT_LIST_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_VALIDATE_TABLE_CLEARED: {
            debug(`ValidatePageReducer ${ACTION_VALIDATE_TABLE_CLEARED} is being processed...`)
            return { ...state, validationResultList: [], totalRecords: 0, metadata: { ...state.metadata, whitelisted: 0 } }
        }//, validationResultList: [], totalRecords: 0, metadata: {...state.metadata, whitelisted: 0}, hiddenHeaders: []

        default:
            return state;
    }
}
